var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 75,
    viewBox: "0 0 77 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.1955,
    cy: 37.5,
    rx: 37.9013,
    ry: 37.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1528 46.8906H21.4795V54.1397H14.1528V46.8906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.869 47.4947H14.7634V53.5356H20.869V47.4947ZM14.1528 46.8906V54.1397H21.4795V46.8906H14.1528Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.439 46.8906H54.1123V54.1397H61.439V46.8906Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7228 47.4947H60.8284V53.5356H54.7228V47.4947ZM61.439 46.8906V54.1397H54.1123V46.8906H61.439Z",
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1353 46.8906H45.4619V54.1397H38.1353V46.8906Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8514 47.4947H38.7458V53.5356H44.8514V47.4947ZM38.1353 46.8906V54.1397H45.4619V46.8906H38.1353Z",
    fill: "#121212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1353 39.0391H45.4619V46.2882H38.1353V39.0391Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8514 39.6432H38.7458V45.6841H44.8514V39.6432ZM38.1353 39.0391V46.2882H45.4619V39.0391H38.1353Z",
    fill: "#121212"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5693 39.6172H45.4614V46.2863H41.5693V39.6172Z",
    fill: "#121212"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8508 40.2213H42.1799V45.6822H44.8508V40.2213ZM41.5693 39.6172V46.2863H45.4614V39.6172H41.5693Z",
    fill: "#121212"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1353 31.1797H45.4619V38.4288H38.1353V31.1797Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8514 31.7838H38.7458V37.8247H44.8514V31.7838ZM38.1353 31.1797V38.4288H45.4619V31.1797H38.1353Z",
    fill: "#121212"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8761 27.0293L45.4619 23.3281V30.5772H38.1353L41.8761 27.0293Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3079 27.4566L39.6545 29.9731H44.8514V24.8313L42.3079 27.4566ZM41.8761 27.0293L38.1353 30.5772H45.4619V23.3281L41.8761 27.0293Z",
    fill: "#121212"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 46.8906H29.4712V54.1397H22.1445V46.8906Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8607 47.4947H22.7551V53.5356H28.8607V47.4947ZM22.1445 46.8906V54.1397H29.4712V46.8906H22.1445Z",
    fill: "#121212"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 39.0391H29.4712V46.2882H22.1445V39.0391Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8607 39.6432H22.7551V45.6841H28.8607V39.6432ZM22.1445 39.0391V46.2882H29.4712V39.0391H22.1445Z",
    fill: "#121212"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 31.1797H29.4712V38.4288H22.1445V31.1797Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8607 31.7838H22.7551V37.8247H28.8607V31.7838ZM22.1445 31.1797V38.4288H29.4712V31.1797H22.1445Z",
    fill: "#121212"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 23.3281H29.4712V30.5772H22.1445V23.3281Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8607 23.9322H22.7551V29.9731H28.8607V23.9322ZM22.1445 23.3281V30.5772H29.4712V23.3281H22.1445Z",
    fill: "#121212"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.127 46.8906H53.4536V54.1397H46.127V46.8906Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8431 47.4947H46.7375V53.5356H52.8431V47.4947ZM46.127 46.8906V54.1397H53.4536V46.8906H46.127Z",
    fill: "#121212"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.127 39.0391H53.4536V46.2882H46.127V39.0391Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8431 39.6432H46.7375V45.6841H52.8431V39.6432ZM46.127 39.0391V46.2882H53.4536V39.0391H46.127Z",
    fill: "#121212"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.127 31.1797H53.4536V38.4288H46.127V31.1797Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8431 31.7838H46.7375V37.8247H52.8431V31.7838ZM46.127 31.1797V38.4288H53.4536V31.1797H46.127Z",
    fill: "#121212"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.127 23.3281H53.4536V30.5772H46.127V23.3281Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8431 23.9322H46.7375V29.9731H52.8431V23.9322ZM46.127 23.3281V30.5772H53.4536V23.3281H46.127Z",
    fill: "#121212"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.136 46.8906H37.4627V54.1397H30.136V46.8906Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8521 47.4947H30.7465V53.5356H36.8521V47.4947ZM30.136 46.8906V54.1397H37.4627V46.8906H30.136Z",
    fill: "#121212"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.136 39.0391H37.4627V46.2882H30.136V39.0391Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8521 39.6432H30.7465V45.6841H36.8521V39.6432ZM30.136 39.0391V46.2882H37.4627V39.0391H30.136Z",
    fill: "#121212"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.136 31.1797H37.4627V38.4288H30.136V31.1797Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8521 31.7838H30.7465V37.8247H36.8521V31.7838ZM30.136 31.1797V38.4288H37.4627V31.1797H30.136Z",
    fill: "#121212"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.136 23.3281L33.7257 27.0256L37.4627 30.5772H30.136V23.3281Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7257 27.0256L30.136 23.3281V30.5772H37.4627L33.7257 27.0256ZM35.9457 29.9731L33.2938 27.4528L30.7465 24.829V29.9731H35.9457Z",
    fill: "#121212"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.562 39.0391H37.1013V46.2882H33.562V39.0391Z",
    fill: "#121212"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4907 39.6432H34.1726V45.6841H36.4907V39.6432ZM33.562 39.0391V46.2882H37.1013V39.0391H33.562Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatToken);
export default __webpack_public_path__ + "static/media/hat-token.7c0c11455c7d3cf9597241cc7a5b0e24.svg";
export { ForwardRef as ReactComponent };